import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../Components/InnerLayout/Headerbar";
import UserInterface from "../../Components/InnerLayout/UserInterface";
import MultiRangeSlider from "../../Components/MultiRangeSlider";
const NonTrade = (params) => {
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content">
          <div className="container px-0">
            <div class="row mx-0">
              <div class="shadowclass top_filters orderpayy">
                <h4 class="event-alert py-0 my-2">Filters </h4>
                <div className="row mx-0">
                  <div class="col-lg-4 col-md-6 pl0 px-0 px-sm-3">
                    <div class="calander d-flex align-items-center">
                      <div class="datePicker pading_right">
                        <div class="input-append bootstrap-timepicker date-input datepicker2 date">
                          <input
                            name="from_date"
                            class=" "
                            required="required"
                            type="text"
                            id=""
                            value="2022-05-01"
                          />
                          <span class="add-on">
                            <i class="fa fa-calendar"></i>
                          </span>
                        </div>
                      </div>
                      <div class="datePicker pading_lect">
                        <div class="input-append bootstrap-timepicker date-input datepicker2 date">
                          <input
                            name="to_date"
                            class=" "
                            required="required"
                            type="text"
                            id=""
                            value="2022-05-13"
                          />
                          <span class="add-on">
                            <i class="fa fa-calendar"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-6 timing-duration pt-4 pt-sm-0">
                    <MultiRangeSlider
                      min={0}
                      max={1000}
                      onChange={({ min, max }) =>
                        console.log(`min = ${min}, max = ${max}`)
                      }
                    />
                  </div>

                  <div class="selecters col-lg-5 col-md-6 pl-md-0 row mx-0 justify-content-between pt-0 pt-lg-0">
                    <div class="select-div col-12 col-lg-5 px-1">
                      <div class="input select">
                        <select
                          name="waste_group"
                          class="csutom_select"
                          id="WasteWasteGroup"
                        >
                          <option value="">Status</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-1 col px-0 pt-3 pt-lg-0">
                    <button class="btn btn_btnblue" type="submit">
                      Search
                    </button>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="top-header-sec mb-3">
              <div className="col-12 mt-3">
                <div className="row justify-content-end align-items-center">
                  <div className="col-lg-3 align-right">
                    <div className="field text-right">
                      <button
                        class="btn green-btn-revert add-plus addSp mx-0"
                        id="addCount"
                        type="button"
                      >
                        <i class="i-icon"> </i> New Purchase Requisition
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion" id="accordionPanelsStayOpenExample">
              <div className="accordion-item">
                <h2
                  className="accordion-header"
                  id="panelsStayOpen-headingNine2"
                >
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseNine2"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseNine2"
                  >
                    <div className="col d-flex align-items-center justify-content-between">
                      <h4 className="event-alert p-0 mb-0">
                        Non-Trade Orders List
                      </h4>
                    </div>
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseNine2"
                  className="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-headingNine2"
                >
                  <div className="">
                    <div className="row mx-0">
                      <div className="container px-0">
                        <div className="shadowclass mt-0">
                          <div className="col-md-4">
                            <div className="search-box mt-0">
                              <form type="GET">
                                <input
                                  type="text"
                                  placeholder="Search"
                                  name="keyword1"
                                />
                                <input type="submit" />
                              </form>
                            </div>
                          </div>
                          <div className="table-responsive general-setting saved_order_ms">
                            <div className="orderList">
                              <table className="checklist-table remove-space">
                                <thead>
                                  <tr>
                                    <th class="min-wd-150">Account</th>
                                    <th>PO#</th>
                                    <th class="min-wd-200">Payee</th>
                                    <th>Status</th>

                                    <th width="110">Total</th>

                                    <th>Spread Type</th>
                                    <th>Contact</th>
                                    <th class="min-wd-150">Created</th>
                                    <th class="min-wd-150">Updated</th>
                                    <th className="actoin-td">Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr class="order_row">
                                    <td>Harry's HQ</td>
                                    <td>0000000014</td>
                                    <td>
                                      <b>A-Speed Infotech Pte Ltd</b> <br />
                                      ID{" "}
                                    </td>
                                    <td>
                                      <span class="received">Received</span>
                                    </td>
                                    <td>$2,140.00</td>

                                    <td>N/A</td>
                                    <td>TBD@tbd.com </td>
                                    <td>May 13, 2022</td>
                                    <td>May 13, 2022</td>
                                    <td ct="61">
                                      <a
                                        class="circle_icon"
                                        href="/Invoices/view/92"
                                      >
                                        <i class="iconSprites eye-icon">
                                          <div class="tooltip-sm"> View </div>
                                        </i>
                                      </a>
                                    </td>
                                  </tr>
                                  <tr class="order_row">
                                    <td>Harry's HQ</td>
                                    <td>0000000013</td>
                                    <td>
                                      <b>1 Sign</b> <br />
                                      ID{" "}
                                    </td>
                                    <td>
                                      <span class="pending">Pending</span>
                                    </td>
                                    <td>$1,070.00</td>

                                    <td>N/A</td>
                                    <td>TBD@tbd.com </td>
                                    <td>May 12, 2022</td>
                                    <td>May 18, 2022</td>
                                    <td ct="60">
                                      <a
                                        href="/Invoices/edit/91"
                                        class="circle_icon edit_tooltip"
                                      >
                                        <i class="iconSprites edit-icon"></i>
                                      </a>
                                    </td>
                                  </tr>
                                  <tr class="order_row">
                                    <td>Harry's HQ</td>
                                    <td>0000000010</td>
                                    <td>
                                      <b>Acoustics Avenue Pte Ltd</b> <br />
                                      ID{" "}
                                    </td>
                                    <td>
                                      <span class="pending">
                                        Pending Purchase Orders
                                      </span>
                                    </td>
                                    <td>$1,070.00</td>

                                    <td>N/A</td>
                                    <td>TBD@tbd.com </td>
                                    <td>Apr 12, 2022</td>
                                    <td>Apr 12, 2022</td>
                                    <td ct="71">
                                      <a class="circle_icon edit_tooltip">
                                        <i class="iconSprites edit-icon"></i>
                                      </a>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default NonTrade;
